export default {
    wait() {
        const container = $('.cForm-ShareAthlete').filter(':visible');
        $('.cForm-ShareAthlete__Error', container).html('');
    },

    done(data) {
        const container = $('.cForm-ShareAthlete').filter(':visible');
        $('.cForm-ShareAthlete__Error', container).html('');
        
        if (data.success) {
            window.location.reload();
            
        } else {
            const errors = $('.cForm-ShareAthlete__Error', container);
            console.log(data.errors, errors)
            for (var k in data.errors) {
                errors.append($('<p>').text(data.errors[k]));
            }
        }
    },

    fail(data) {
    },
};



// WEBPACK FOOTER //
// ./assets/js/component/ajax/share-athlete.js